import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Attendance {
	async getAll(pgid: PGSchema.pages["id"], params?: { from_ts?: number; to_ts?: number; uid?: string }, token?: string) {
		return xget<{ items: PGSchema.hcm_attendances[] }>(`/pages/${pgid}/attendances`, params, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getOne(pgid: PGSchema.pages["id"], itemId: string, token?: string) {
		return xget<{ attendance: PGSchema.hcm_attendances; agreement?: PGSchema.hcm_agreements }>(`/pages/${pgid}/attendances/${itemId}`, undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async create(pgid: PGSchema.pages["id"], data: Omit<PGSchema.hcm_attendances, "id" | "created_at" | "updated_at" | "pgid">, token?: string) {
		return xhttp<PGSchema.hcm_attendances>(`/pages/${pgid}/attendances`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async update(pgid: PGSchema.pages["id"], itemId: string, data: Partial<Omit<PGSchema.hcm_attendances, "id" | "created_at" | "updated_at" | "pgid">>, token?: string) {
		return xhttp<PGSchema.hcm_attendances>(`/pages/${pgid}/attendances/${itemId}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async approveAll(
		pgid: PGSchema.pages["id"],
		data: {
			id: PGSchema.hcm_attendances["id"][];
		},
		token?: string
	) {
		return xhttp<{ items: PGSchema.hcm_attendances[] }>(`/pages/${pgid}/attendances/approve-all`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async fillAll(
		pgid: PGSchema.pages["id"],
		data: {
			from_ts: string;
			to_ts: string;
			uid?: PGSchema.hcm_attendances["uid"][];
		},
		token?: string
	) {
		return xhttp<{
			success: boolean;
			edited: number;
			created: number;
			timezone: number;
		}>(`/pages/${pgid}/attendances/fill-all`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async delete(pgid: PGSchema.pages["id"], itemId: string, token?: string) {
		return xhttp<{ deleted: boolean }>(
			`/pages/${pgid}/attendances/${itemId}`,
			"DELETE",
			{},
			{
				headers: token ? { "app-token": token } : undefined
			}
		);
	}
}
